export const BASE_PATH = {
    SECURITY: '/security',
};

export const API_PATHS = {
    CHECK_SESSION: '/checkSession',
};

/**
 * Experience API 패키지 URL
 * @type {string}
 */
const packages = {
    holdings: `/holdings`,
};

/**
 * Experience API 업무 구분 URL
 * @type {string}
 */
const sectors = {
    holdings: {
        assets: `${packages.holdings}/assets`,
    },
};

/**
 * Experience API 업무 세구분 URL
 * @type {string}
 */
const details = {
    holdings: {
        assets: {
            setting: `${sectors.holdings.assets}/setting`,
        },
    },
};

/**
 * Experience API 엔드포인트 URL
 * @type {string}
 */
export const APIS = {
    holdings: {
        assets: {
            setting: {
                setLogoutPopup: `${details.holdings.assets.setting}/setLogoutPopup`,
            },
        },
    },
};